var _circle, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCheckCircleFilledGreen = function SvgCheckCircleFilledGreen(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.8335,
    cy: 15,
    r: 14.25,
    fill: "#57B7AB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19.7917,
    height: 19.7917,
    transform: "translate(5.3335 4.70837)",
    fill: "#57B7AB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5864 17.7998L9.14757 14.361L7.97656 15.5237L12.5864 20.1335L22.4822 10.2377L21.3194 9.07495L12.5864 17.7998Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCheckCircleFilledGreen);
export { ForwardRef as ReactComponent };